// extracted by mini-css-extract-plugin
export var truncate = "_9-0";